module.exports = __webpack_public_path__ + "static/media/211EC127.171433c1.jpg";